// @module NVT.SSO_Mechanism.SSOMechanism
define('NVT.SSO_Mechanism.SSOMechanism.View'
	, [
		'nvt_sso_mechanism_ssomechanism.tpl'

		, 'NVT.SSO_Mechanism.SSOMechanism.SS2Model'

		, 'Backbone'

		, 'Profile.Model',

		'Utils'
	]
	, function (
		nvt_sso_mechanism_ssomechanism_tpl

		, SSOMechanismSS2Model

		, Backbone

		, ProfileModel

		, Utils
	) {
		'use strict';

		// @class NVT.SSO_Mechanism.SSOMechanism.View @extends Backbone.View
		return Backbone.View.extend({

			template: nvt_sso_mechanism_ssomechanism_tpl

			, title: Utils.translate("Services")

			, page_header: Utils.translate("Services")

			, getSelectedMenu: function getSelectedMenu() {
				return 'ssoservicelist'
			}
			, getBreadcrumbPages: function () {
				return {
					text: Utils.translate("Services"),
					href: '/ssoservicelist'
				};
			}

			, initialize: function (options) {
				this.model = new SSOMechanismSS2Model();
				var self = this;

				var profile = ProfileModel.getInstance();
				var isLoggedIn = profile.get('isLoggedIn') === 'T';
				// if (isLoggedIn) {
				this.model.fetch({
					async: false,
					data: {
						getmethod: 'ssoservicelist',
						csfragment: '',
						compNameparam: profile.get('companyname'),
						contactid: profile.get('contactId'),
						loginTypess: profile.get('type'),
						internalid: profile.get('internalid'),
						compparam: profile.get('email'),
						isLoggedIn: isLoggedIn
					}
				}).done(function (result) {
					if (result && result.length > 0) {
						self.isservicelist = result;
					}
					else{
						self.isservicelist = [];
					}
					self.render();
				});

				// } else {
				// var fragment = Backbone.history.getFragment();
				// if (fragment.indexOf('checkout.ssp') === -1) {
				// 	sessionStorage.setItem('redirectAfterLogin', '/ssoservicelist');
				// 	window.location.href = SC.CONFIGURATION.siteSettings.touchpoints.login;
				// }
				// }
			}


						, events: {
				'click button[data-action="want-to-sso-login"]': 'wanttossologin',
			}

			, wanttossologin: function (e) {
				var self = this;
				var selectedType = e.currentTarget.value;
				var newredirectUrl = '';


				var tempservice = self.isservicelist.find(
					item => item.fragmentType === selectedType
				);

				if (tempservice && tempservice.fragmentType.length > 0) {
					newredirectUrl = tempservice.redirectUrl;
					console.log('Redirect URL:', newredirectUrl);
				}

				if (newredirectUrl) {

					// Remove query string if required
					var cleanRedirectUrl = newredirectUrl.split('?')[0];
					var token = Utils.getParameterByName(newredirectUrl, 'token');
					fetch(cleanRedirectUrl + "/api/auth/sso-token", {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							token: token
						}),
						credentials: 'include'
					})
						.then(function (fetchResponse) {
							if (!fetchResponse.ok) {
								throw new Error(
									'HTTP ' +
									fetchResponse.status +
									' - ' +
									fetchResponse.statusText
								);
							}
							return fetchResponse.json();
						})
						.then(function (data) {

							console.log('SSO Token Validation Response:', data);

							if (data && data.user && data.user.id) {

								// Option 1
								var updateurl =
									cleanRedirectUrl + "/chat=" + data.user.id;

								window.location.href = updateurl;

							} else {

								//alert('SSO Login Failed.\nReason: ' +(data?.message || 'Server rejected the request.'));
							}
						})
						.catch(function (error) {
							console.error(error);
							//alert('SSO Login Failed.\nError: ' +error.message);
						});
				}


			}

			, bindings: {

			}

			, childViews: {

			}
			// , getServicesForMenu: function () {
			// 	if (!this.isservicelist) return [];
			// 	return this.isservicelist.map(service => ({
			// 		isLoggedIn: service.isLoggedIn,
			// 		fragmentType: service.fragmentType,
			// 		redirectUrl: service.redirectUrl,
			// 		description: service.description,
			// 		serviceIcon: service.serviceIcon || '🔹'
			// 	}));
			// }


			//@method getContext @return NVT.SSO_Mechanism.SSOMechanism.View.Context
			, getContext: function getContext() {
				//@class NVT.SSO_Mechanism.SSOMechanism.View.Context
				return {
					// @property {Boolean} page_header
            		page_header : this.page_header,
					// @property {string} isservice list
					isservicelist: this.isservicelist
				};
			}
		});
	});
